import { ENABLE_LOCALIZATION } from '@/constants/featureFlags'
import { getHost } from '@/utils/host'

const CATALOG_NOT_FOUND_CODES = [400, 418]

export const actions = {
  async nuxtServerInit({ dispatch }, { req, error }) {
    try {
      const host = getHost(req)
      if (process.env.NODE_ENV === 'development') {
        console.log(`Loading catalog: ${host}`)
      }
      const { school } = await dispatch('settings/fetch', {
        url: host,
      })
      // disabling the rule to make the const explicit. Curious if we need to fetch this data; maybe it's used somewhere down the line
      // directly taken from store, or maybe we can drop it. Please investigate if you read this and have some time. Thank you!
      // eslint-disable-next-line no-unused-vars
      const [_displayName, _departments, flags, _terms] = await Promise.all([
        dispatch('settings/fetchDisplayName', { school }),
        // TODO: We don’t necessarily need this during SSR
        //       Might reduce the request load
        // dispatch('reports/fetchRecentCatalogPdf', { school, catalogId }),
        dispatch('departments/fetch', { school }),
        this.$featureFlags.featureFlagsService.getAllFlags(school),
        dispatch('terms/fetchTerms', { school }),
      ])

      dispatch('settings/initFlags', { flags })

      // Always reset localization to defaults first to prevent cross-request contamination
      this.$updateLocalization({
        localizations: {},
        dateFormat: '',
        timeFormat: ''
      })

      // Fetch and initialize localization if enabled
      if (flags[ENABLE_LOCALIZATION]) {
        try {
          const response = await this.$axios.$get(`/${school}/general/localizations`)
          const localizationSettings = response?.localizations?.[response.deafult || 'en-us']

          if (localizationSettings) {
            this.$updateLocalization({
              localizations: localizationSettings.localizations || {},
              dateFormat: localizationSettings.dateFormat || '',
              timeFormat: localizationSettings.timeFormat || ''
            })
          }
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            console.warn(`Failed to fetch localizations for school ${school}:`, error)
          }
        }
      }
    } catch (err) {
      if (CATALOG_NOT_FOUND_CODES.includes(err.response?.status)) {
        console.error(err.response?.data?.error)
        error({
          statusCode: 404,
          message: 'Page not found',
          name: 'NO_CATALOG',
        })
      } else {
        this.$bugsnag.notify(err)
        throw err
      }
    }
  },
}
